var _userInfo = '';

exports.getUserInfo = function () {
  return _userInfo;
};

exports.setUserInfo = function (userInfo) {
  _userInfo = userInfo;
};
